import { showNotification } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';
import { X } from 'tabler-icons-react';
import axios, { axiosPrivate } from '../api/axios';
import { ErrorResponse } from '../type/error-response.types';
import useAuth from './useAuth';

const LOGOUT_URL: string = '/web/auth/signout';

const useLogout = () => {
  // const axiosPrivate = useAxiosPrivate();
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  return async (): Promise<void> => {
    try {
      await axios.post(LOGOUT_URL, null, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${auth?.accessToken}` },
      });
      setAuth({});

      // TODO refreshing the page is kinda bad UX, so try to explore other options
      // try to comment window.location.reload() next time, because apparently setAuth({})
      // takes us to the sign in page already, might be far fetched but it might work
      // the combination of setAuth({}) and navigate('/login') might be the reason why the bug was present before

      // Refresh page to get rid of access token for sure
      window.location.reload();
      // navigate('/login');

      axiosPrivate.defaults.headers.common['Authorization'] = '';
    } catch (err: any) {
      if (err.response?.status === 401) {
        setAuth({});
        window.location.reload();
        // navigate('/login');
      } else {
        const error: ErrorResponse = err.response?.data;
        showNotification({
          id: 'failed-to-logout',
          message: error.error || 'An Unexpected Error Occurred',
          icon: <X size={16} />,
          color: 'red',
          autoClose: 10000,
        });
      }
    }
  };
};

export default useLogout;
